import {
  gridGutter,
  gridGutter1q1dot5,
  gridGutter1q4,
  gridGutter1q3
} from "@maxmilhas/hangar-components-atomic/public/styles/components/quarks/layout";

import theme from "../../../../../../../js/shared/new-theme";

export const loadingStyle = `
	display: flex;
	justify-content: center;
	padding: 64px 0;
	width: 100%;
`;

export const editFidelityAndBank = `
  .edit-fidelity-program-and-bank-details {
    padding: ${gridGutter1q4}px ${gridGutter}px;
    h6 {
      margin-bottom: ${gridGutter}px;
    }
    .form-group {
      margin-bottom: ${gridGutter1q1dot5}px;
    }
    &--forgot-password {
      display: flex;
      justify-content: flex-end;
      padding-top: ${gridGutter1q3}px;

      a {
        font-size: 14px; //fontSize14
        color: ${theme.palette.gray[600].value};
        font-weight: normal;
        cursor: pointer;
        &:hover {
          color: ${theme.palette.gray[700].value};
        }
      }
    }

    &--phone-chek {	
      display: flex;
      gap: 4px;
      padding-top: 3px;
      font-size: 12px;
  
      i {
        color: ${theme.palette.green[600].value};
      }
    }
  }
`;

export const latamWarningContainer = `
  padding: 0px 32px;

  a {
    font-weight: bold;
    color: ${theme.palette.gray[800].value};
    text-decoration: underline;
  }
`;